import React from 'react';
import ContactsTable from './contacts-tab';
import BillingAdminsContactTable from './billing-admins-contact-table';
import { EntitlementDetails } from '@css-xp/graphtypes/src/generated-types-new';

const PeopleTab = ({ entitlement }: { entitlement: EntitlementDetails }) => {
  return (
    <div className="statuspage-tab" data-testid="statuspage-people-tab">
      <BillingAdminsContactTable entitlement={entitlement} />
      <ContactsTable entitlement={entitlement} />
    </div>
  );
};

export default PeopleTab;
